import React from "react";
import {
  ApprovedSign,
  InitialReviewSign,
  InProgressSign,
  PendingSign,
  RejectedSign,
} from "../../../../../Icons";

const GetTransactionStatus = ({ status }) => {
  switch (status) {
    case "INITIATED":
      return (
        <>
          <InitialReviewSign />
          <span className={"px-1 text-blue-400"}>Initiated</span>
        </>
      );
    case "Initial Review":
      return (
        <>
          <InitialReviewSign />
          <span className={"px-1 text-blue-500"}>{status}</span>
        </>
      );
    case "Pending":
      return (
        <>
          <PendingSign />
          <span className={"px-1 text-dark-primary font-medium"}>{status}</span>
        </>
      );
    case "Approved":
      return (
        <>
          <ApprovedSign />
          <span className={"px-1 text-success-500"}>{status}</span>
        </>
      );
    case "Rejected":
      return (
        <div className="flex flex-col items-end max-w-[196px] max-h-16">
          <div className="flex items-center justify-end">
            <RejectedSign className="w-3 h-3" />
            <span className={"px-1 text-error-500"}>{status}</span>
          </div>
        </div>
      );
    case "Draft":
      return (
        <>
          <div className="w-3 h-3 rounded-full bg-gray-400 mr-1"></div>
          <span className={"px-1 text-dark-primary font-medium"}>{status}</span>
        </>
      );
    case "In Progress":
      return (
        <>
          <InProgressSign />
          <span className={"px-1 text-dark-primary font-medium"}>{status}</span>
        </>
      );
    default:
      return status;
  }
};

export default GetTransactionStatus;
